import { render, staticRenderFns } from "./UserViewRecup.vue?vue&type=template&id=3a76b288&scoped=true"
import script from "./UserViewRecup.vue?vue&type=script&lang=js"
export * from "./UserViewRecup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a76b288",
  null
  
)

export default component.exports